import { mapMutations } from 'vuex';

export default {
  methods: {
    ...mapMutations('OD', ['updateOdLocalFileStatus']),
    ...mapMutations('war/transaction', ['updateWarLocalFileStatus']),
    ...mapMutations('misc/miscTransaction', ['updateMiscLocalFileStatus']),
    ...mapMutations('mtg/mtgTransaction', ['updateMtgLocalFileStatus']),
    ...mapMutations('tax/taxInquires', ['updateTaxInquiryTransactionLocalFileStatus']),
    ...mapMutations('tax/taxPayment', ['updatePaymentLocalFileStatus']),
    // `uploaded`: the caller knows a file was just attached. After a long batch the shared
    // fileCount may describe another record's list, so it can't be trusted then.
    fileUploadPaperClipUpdate(uploaded = false) {
      // > 0, not === 1: a bulk upload can take a record from 0 straight to many files.
      if (uploaded || this.fileCount > 0) {
        switch (this.parentObjectType) {
          case 'ODTransaction':
            this.updateOdLocalFileStatus({ objectId: this.parentObjectId, status: true });
            break;
          case 'warTransaction':
            this.updateWarLocalFileStatus({ objectId: this.parentObjectId, status: true });
            break;
          case 'miscTransaction':
            this.updateMiscLocalFileStatus({ objectId: this.parentObjectId, status: true });
            break;
          case 'mtgTransaction':
            this.updateMtgLocalFileStatus({ objectId: this.parentObjectId, status: true });
            break;
          case 'taxInquiryTransaction':
            this.updateTaxInquiryTransactionLocalFileStatus({
              objectId: this.parentObjectId,
              status: true,
            });
            break;
          case 'taxPayments':
            this.updatePaymentLocalFileStatus({ objectId: this.parentObjectId, status: true });
            break;
          default:
            break;
        }
      }
    },
    fileDeletePaperClipUpdate() {
      if (this.fileCount === 0) {
        switch (this.parentObjectType) {
          case 'ODTransaction':
            this.updateOdLocalFileStatus({ objectId: this.parentObjectId, status: false });
            break;
          case 'warTransaction':
            this.updateWarLocalFileStatus({ objectId: this.parentObjectId, status: false });
            break;
          case 'miscTransaction':
            this.updateMiscLocalFileStatus({ objectId: this.parentObjectId, status: false });
            break;
          case 'mtgTransaction':
            this.updateMtgLocalFileStatus({ objectId: this.parentObjectId, status: false });
            break;
          case 'taxInquiryTransaction':
            this.updateTaxInquiryTransactionLocalFileStatus({
              objectId: this.parentObjectId,
              status: false,
            });
            break;
          case 'taxPayments':
            this.updatePaymentLocalFileStatus({ objectId: this.parentObjectId, status: false });
            break;

          default:
            break;
        }
      }
    },
  },
};
